<template>
  <AppModal :id="id">

    <template #title>
      <h3 v-if="log.status === 'Success'" class="text-center mb-5">
        {{$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_success_title) | capitalize}}
      </h3>
      <h3 v-if="log.status === 'Failed'" class="text-center text-warning mb-5">
        {{$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_failed_title) | capitalize}}
      </h3>
    </template>

    <template #content>

      <template
        v-if="log.status === 'Report done' || log.status === 'Import in progress'|| log.status === 'Import done' || log.status === 'Import failed'">
        <b-list-group id="success-rapport" class="my-3">
          <b-list-group-item class="bg-light d-flex justify-content-between align-items-center font-weight-bold">
            {{$t($getConst.pages.invoice.rapport_total_invoices)}}
            <span>{{logDetails.invoicesCount}}</span>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            {{$t($getConst.pages.invoice.rapport_invoices_to_create)}}
            <span>{{logDetails.invoicesToCreate}}</span>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            {{$t($getConst.pages.invoice.rapport_invoices_to_update)}}
            <span>{{logDetails.invoicesToUpdate}}</span>
          </b-list-group-item>
        </b-list-group>

        <b-list-group v-if="logDetails.timesheetsToCreate.length > 0">
          <a type="button" v-b-toggle="'row-timesheets'"
             class="bg-warning list-group-item d-flex justify-content-between align-items-center py-2 px-4">
            {{$t($getConst.pages.invoice.rapport_timesheets_not_found)}}
            ({{logDetails.timesheetsToCreate.length}})
            <span><i :class="$getConst.icons.chevron_down"/></span>
          </a>
          <b-collapse id="row-timesheets" accordion="my-accordion" class="list-group-item">
            <ul class="mb-0">
              <li v-for="timesheet in logDetails.timesheetsToCreate">
                {{timesheet}}
              </li>
            </ul>
          </b-collapse>
        </b-list-group>
      </template>

      <b-list-group id="failed-rapport" v-else-if="log.status === 'Invalid data'" class="overflow-auto">
        <b-list-group-item class="d-flex justify-content-between align-items-center text-danger">
          <h5>
            <b>{{$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_total_invalid_timesheets)}}</b>
          </h5>
          <span class="badge badge-danger badge-pill w-auto">{{Object.keys(logDetails).length}}</span>
        </b-list-group-item>
        <template v-for="(errors, row) in logDetails">
          <a type="button" v-b-toggle="'row-'+row"
             class="list-group-item d-flex justify-content-between align-items-center py-2 px-4">
            {{$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_row)}} {{row}}
            <span><i :class="$getConst.icons.chevron_down"/></span>
          </a>
          <b-collapse :id="'row-'+row" accordion="my-accordion" class="list-group-item">
            <ul class="mb-0">
              <li v-for="error in errors">
                {{Object.keys(error)[0]}}:
                <span class="float-right">{{$t($getConst.pages.vendor_timesheets["vendor_timesheets_rapport_"+Object.values(error)[0]])}}</span>
              </li>
            </ul>
          </b-collapse>

        </template>
      </b-list-group>

    </template>

    <template #button>
      <AppConfirmButtons :firstButton="log.status === 'Report done' || log.status === 'Import failed'"
                         :submit-text="$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_import_timesheets)"
                         :is-loading="isLoading"
                         @onSubmit="dispatchImportInvoicesJob"
                         @onCancel="close"
      />
    </template>

  </AppModal>
</template>

<script>
  import AppModal from "../../../../components/common/modals/AppModal";
  import AppConfirmButtons from "../../../../components/common/utils/AppConfirmButtons";
  import {dispatchImportInvoicesJob} from "../../../../api/invoices.api";

  export default {
    name: "ImportInvoicesReportModal",
    components: {AppConfirmButtons, AppModal},
    props: ['log', 'id'],
    data() {
      return {
        isLoading: false
      }
    },
    computed: {
      logDetails() {
        return JSON.parse(this.log.details);
      }
    },
    methods: {
      close() {
        this.$bvModal.hide(this.id);
        this.$emit('onCancel');
      },
      dispatchImportInvoicesJob() {
        this.isLoading = true;
        dispatchImportInvoicesJob(this.log.id).then(
          () => {
            this.$emit('dispatchImportInvoicesJob');
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
            this.close();
            this.isLoading = false;
          },
          error => {
            if (error.response.data.code === 422) {
              this.$snotify.error(error.response.data.error, this.$t(this.$getConst.pages.alerts.error));
            } else {
              this.handleApiError(error);
            }
            this.isLoading = false;
            this.close();
          }
        );

      }
    }
  }
</script>

<style scoped>

</style>
